import { useState } from "react";
import { IInstantNotification, IInstantNotifier } from "./types";
import { ILog } from "../Log/types";


const useInstantNotifierService = (maxItems: number, log: ILog): IInstantNotifier => {

    const maxItemsNorm = Math.max(1, maxItems);
    const [items, setItems] = useState<IInstantNotification[]>([]);

    const pop = (): IInstantNotification | null => {
      const newValues = [...items];
      const item = newValues.pop();
      setItems(newValues);
      return item ?? null;
    }

    const clear =  () => {
      setItems([]);
    }
    
    const error = (message: string, error: any | null) => {
      let newValues = [...items];
      newValues.unshift({ style: 'error', text: message });
      newValues = newValues.slice(0, maxItemsNorm);
      log.error(`Error Notification: ${message}`, error);
      setItems(newValues);
    }

    const success = (message: string) => {
      let newValues = [...items];
      newValues.unshift({ style: 'success', text: message });
      newValues = newValues.slice(0, maxItemsNorm);
      log.info(`Success Notification: ${message}`);
      setItems(newValues);
    }

    const info = (message: string) => {
      let newValues = [...items];
      newValues.unshift({ style: 'info', text: message });
      newValues = newValues.slice(0, maxItemsNorm);
      log.info(`Info Notification: ${message}`);
      setItems(newValues);
    }

    return { 
        items, 
        pop, 
        clear, 
        error, 
        success, 
        info
    }

};

export default useInstantNotifierService;